import axios from "api/axios";

// App Backend
export const getAllTemplates = async () => {
  const response = await axios.get("/api/templates/");
  return response.data;
};

export const getAllTemplatesUserIdSortByProfession = async (userId) => {
  const response = await axios.get(`/api/templates/user/${userId}`);
  return response.data;
};

export const saveTemplate = async (data) => {
  const response = await axios.post('/api/templates/custom', data);
  return response.data;
}

export const getAllCustomTemplates = async () => {
  const response = await axios.get('/api/templates/custom');
  return response.data;
}

export const deleteCustomTemplate = async ({ templateId }) => {
  const response = await axios.delete(`/api/templates/template/${templateId}`);
  return response.data;
}

export const getFullTemplateDetails = async (templateId) => {
  const res = await axios.get("/api/templates/full-custom-Details/" + templateId);
  return res.data;
}

export const updateTemplate = async (data) => {
  const res = await axios.put("/api/templates/custom", data);
  return res.data;
}